import Background from "../../../../picture/adminLogin.jpeg";
import Logo from "../../../../picture/Logo.png";
import {Box, Button, TextField, Typography} from "@mui/material";
import React, {useState} from "react";
import {findIdService, findInfoSMS} from "../../../../api";
import Store from "../../../../context/store";
import {Desktop, Mobile, Tablet} from "../../../../Responsive";


export default function FindId(){

    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [authNum, setAuthNum]= useState("")

    const [NameMessage, setNameMessage] = useState("")
    const [PhoneMessage, setPhoneMessage] = useState("")
    const [isName, setIsName] = useState(false)
    const [isPhone,setIsPhone] = useState(false)
    const [isAuthNum, setIsAuthNum]= useState(false)
    const [isSendAuthNum, setIsSendAuthNum]= useState(false)
    const [reSend,setResend] =useState(0)


    const onChangeName = (e) => {
        const currentName = e.currentTarget.value;
        setName(currentName)
        const nameRegExp = /^[가-힣a-zA-Z]+$/;

        if (!nameRegExp.test(currentName) || name.length<1) {
            setNameMessage('이름을 두 글자 이상 입력하세요!');
            setIsName(false);
        } else {
            setNameMessage('');
            setIsName(true);
        }

    }

    const onChangePhone = (getNumber) => {
        const currentPhone = getNumber;
        setPhone(currentPhone);
        const phoneRegExp = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;

        if (!phoneRegExp.test(currentPhone)) {
            setPhoneMessage("핸드폰 번호를 입력해 주세요!");
            setIsPhone(false);
        } else {
            setPhoneMessage("");
            setIsPhone(true);
        }
    };
    const addHyphen = (e) => {
        const currentNumber = e.currentTarget.value;
        setPhone(currentNumber);
        if (currentNumber.length === 3 || currentNumber.length === 8) {
            setPhone(currentNumber + "-");
            onChangePhone(currentNumber + "-");
        } else {
            onChangePhone(currentNumber);
        }
    };

    const onChangeAuthNum = (e) =>{
        const currentNumber = e.currentTarget.value;
        setAuthNum(currentNumber)
        if(currentNumber.length === 6){
            setIsAuthNum(true)
        }else{
            setIsAuthNum(false)
        }

    }


    const sendSmsHandler=(e)=>{
        e.preventDefault()
        let data ={
            name:name,
            phone:phone,
            phoneSubject:'아이디 찾기'
        }
        findInfoSMS(data)
            .then(res=>{
                alert(res.data)
                setIsSendAuthNum(true)
                setResend(1)
            })
            .catch(err=>{
                alert(JSON.stringify(err.response.data))
                setIsSendAuthNum(false)
            })
    };
    const onSubmitHandler=(e)=>{
        e.preventDefault()
        let data = {
            authNum:authNum,
            name:name,
            phone:phone
        }
        findIdService(data)
            .then(res=>{
                setResend(0)
                alert(`가입된 아이디는 ${res.data} 입니다.`)
                Store().setFindData(res.data)
                window.location.replace('/')
            })
            .catch(err=>{
                alert(JSON.stringify(err.response.data))
            })

    }

    return(
        <>
            <Desktop>
                <div style={{backgroundImage:`url(${Background})`,
                    backgroundSize:'cover'}}>
                    <div style={{alignItems:'revert-layer',display:'inline-table',flexDirection:'column',paddingBottom:400
                        ,position:'sticky',paddingLeft:100}}>

                        <div style={{display:'flex',alignItems:'flex-end',flexDirection:"column"}}>
                            <Box
                                component="form"
                                sx={{
                                    marginTop: 10,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    backgroundColor: 'white',
                                    width: '450px',
                                    borderRadius:'0.5rem',
                                    border:1,
                                    borderColor:'grey.500',
                                    opacity:0.8,

                                }}><br/>
                                <img alt="No Images" src={Logo} style={{width:350,height:110,paddingRight:30}}/><br/>
                                <Typography component="h1" variant="h5" sx={{paddingBottom:2}}>
                                    아이디 찾기
                                </Typography>

                                <TextField
                                    onChange={onChangeName}
                                    disabled={isSendAuthNum === true}
                                    value={name}
                                    margin="normal"
                                    required
                                    sx={{width:360}}
                                    label="이름(성함)"
                                    name="name"
                                    autoFocus
                                    error={isName === false}
                                />
                                <div>
                                    <TextField
                                        value={phone}
                                        disabled={isSendAuthNum === true}
                                        onChange={addHyphen}
                                        margin="normal"
                                        name="phone"
                                        required
                                        sx={{width:220}}
                                        label="전화번호"
                                        error={isPhone === false}
                                    />
                                    {reSend === 1 ? (
                                        <>
                                            <Button
                                                disabled={isName === false || isPhone === false}
                                                onClick={sendSmsHandler}
                                                type="submit"
                                                variant="outlined"
                                                size="large"
                                                sx={{ mt: 2, mb: 2, ml:2,
                                                    width:130,
                                                    height:55,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                재전송
                                            </Button>
                                        </>
                                    ):(
                                        <>
                                            <Button
                                                disabled={isName === false || isPhone === false}
                                                onClick={sendSmsHandler}
                                                type="submit"
                                                variant="outlined"
                                                size="large"
                                                sx={{ mt: 2, mb: 2, ml:2,
                                                    width:130,
                                                    height:55,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                인증번호 전송
                                            </Button>
                                        </>
                                    )}

                                </div>

                                <TextField
                                    disabled={isSendAuthNum === false}
                                    onChange={onChangeAuthNum}
                                    value={authNum}
                                    margin="normal"
                                    required
                                    sx={{width:360}}
                                    label="인증번호"
                                    name="authNum"
                                />

                                <Button
                                    disabled={isAuthNum === false}
                                    onClick={onSubmitHandler}
                                    type="submit"
                                    variant="outlined"
                                    size="large"
                                    sx={{ mt: 2, mb: 2,
                                        width:360,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    아이디 찾기
                                </Button>

                                <Button
                                    href='/'
                                    variant="contained"
                                    required
                                    fullWidth
                                    size="large"
                                    style={{
                                        mt:3,
                                        mb:2,
                                        width:360,
                                        marginTop:2,
                                        marginBottom:10,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography variant='body2' color="primary.contrastText">
                                        Home (뒤로가기)</Typography>
                                </Button><br/>


                            </Box>


                        </div>
                    </div>
                </div>
            </Desktop>
            <Tablet>
                <div style={{backgroundImage:`url(${Background})`,
                    backgroundSize:'contain'}}>
                    <div style={{alignItems:'revert-layer',display:'inline-table',flexDirection:'column',paddingBottom:600
                        ,position:'sticky',paddingLeft:100}}>

                        <div style={{display:'flex',alignItems:'flex-end',flexDirection:"column"}}>
                            <Box
                                component="form"
                                sx={{
                                    marginTop: 10,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    backgroundColor: 'white',
                                    width: '450px',
                                    borderRadius:'0.5rem',
                                    border:1,
                                    borderColor:'grey.500',
                                    opacity:0.8,

                                }}><br/>
                                <img alt="No Images" src={Logo} style={{width:350,height:110,paddingRight:30}}/><br/>
                                <Typography component="h1" variant="h5" sx={{paddingBottom:2}}>
                                    아이디 찾기
                                </Typography>

                                <TextField
                                    onChange={onChangeName}
                                    disabled={isSendAuthNum === true}
                                    value={name}
                                    margin="normal"
                                    required
                                    sx={{width:360}}
                                    label="이름(성함)"
                                    name="name"
                                    autoFocus
                                    error={isName === false}
                                />
                                <div>
                                    <TextField
                                        value={phone}
                                        disabled={isSendAuthNum === true}
                                        onChange={addHyphen}
                                        margin="normal"
                                        name="phone"
                                        required
                                        sx={{width:220}}
                                        label="전화번호"
                                        error={isPhone === false}
                                    />
                                    {reSend === 1 ? (
                                        <>
                                            <Button
                                                disabled={isName === false || isPhone === false}
                                                onClick={sendSmsHandler}
                                                type="submit"
                                                variant="outlined"
                                                size="large"
                                                sx={{ mt: 2, mb: 2, ml:2,
                                                    width:130,
                                                    height:55,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                재전송
                                            </Button>
                                        </>
                                    ):(
                                        <>
                                            <Button
                                                disabled={isName === false || isPhone === false}
                                                onClick={sendSmsHandler}
                                                type="submit"
                                                variant="outlined"
                                                size="large"
                                                sx={{ mt: 2, mb: 2, ml:2,
                                                    width:130,
                                                    height:55,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                인증번호 전송
                                            </Button>
                                        </>
                                    )}

                                </div>

                                <TextField
                                    disabled={isSendAuthNum === false}
                                    onChange={onChangeAuthNum}
                                    value={authNum}
                                    margin="normal"
                                    required
                                    sx={{width:360}}
                                    label="인증번호"
                                    name="authNum"
                                />

                                <Button
                                    disabled={isAuthNum === false}
                                    onClick={onSubmitHandler}
                                    type="submit"
                                    variant="outlined"
                                    size="large"
                                    sx={{ mt: 2, mb: 2,
                                        width:360,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    아이디 찾기
                                </Button>

                                <Button
                                    href='/'
                                    variant="contained"
                                    required
                                    fullWidth
                                    size="large"
                                    style={{
                                        mt:3,
                                        mb:2,
                                        width:360,
                                        marginTop:2,
                                        marginBottom:10,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography variant='body2' color="primary.contrastText">
                                        Home (뒤로가기)</Typography>
                                </Button><br/>


                            </Box>


                        </div>
                    </div>
                </div>
            </Tablet>
            <Mobile>
                <div style={{backgroundImage:`url(${Background})`,
                    backgroundSize:'contain'}}>
                    <div style={{alignItems:'center',display:'flex',flexDirection:'column',paddingBottom:600
                        }}>
                        <div style={{display:'flex',alignItems:'center',flexDirection:"column"}}>
                            <Box
                                component="form"
                                sx={{
                                    marginTop: 10,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    backgroundColor: 'white',
                                    width: '350px',
                                    borderRadius:'0.5rem',
                                    border:1,
                                    borderColor:'grey.500',
                                    opacity:0.9,

                                }}><br/>
                                <img alt="No Images" src={Logo} style={{width:280,paddingRight:30}}/><br/>
                                <Typography component="h1" variant="h5" sx={{paddingBottom:2}}>
                                    아이디 찾기
                                </Typography>

                                <TextField
                                    onChange={onChangeName}
                                    disabled={isSendAuthNum === true}
                                    value={name}
                                    margin="normal"
                                    required
                                    size='small'
                                    sx={{width:300}}
                                    label="이름(성함)"
                                    name="name"
                                    autoFocus
                                    error={isName === false}
                                />
                                <div>
                                    <TextField
                                        value={phone}
                                        disabled={isSendAuthNum === true}
                                        onChange={addHyphen}
                                        margin="normal"
                                        name="phone"
                                        required
                                        size='small'
                                        sx={{width:200}}
                                        label="전화번호"
                                        error={isPhone === false}
                                    />
                                    {reSend === 1 ? (
                                        <>
                                            <Button
                                                disabled={isName === false || isPhone === false}
                                                onClick={sendSmsHandler}
                                                type="submit"
                                                variant="outlined"
                                                size="small"
                                                sx={{ mt: 2, mb: 2, ml:1,
                                                    width:130,
                                                    height:40,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                재전송
                                            </Button>
                                        </>
                                    ):(
                                        <>
                                            <Button
                                                disabled={isName === false || isPhone === false}
                                                onClick={sendSmsHandler}
                                                type="submit"
                                                variant="outlined"
                                                size="small"
                                                sx={{ mt: 2, mb: 2, ml:1,
                                                    width:100,
                                                    height:40,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                인증번호 전송
                                            </Button>
                                        </>
                                    )}

                                </div>

                                <TextField
                                    disabled={isSendAuthNum === false}
                                    onChange={onChangeAuthNum}
                                    value={authNum}
                                    margin="normal"
                                    required
                                    size='small'
                                    sx={{width:300}}
                                    label="인증번호"
                                    name="authNum"
                                />

                                <Button
                                    disabled={isAuthNum === false}
                                    onClick={onSubmitHandler}
                                    type="submit"
                                    variant="outlined"
                                    size="small"
                                    sx={{ mt: 2, mb: 2,
                                        width:300,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    아이디 찾기
                                </Button>

                                <Button
                                    href='/'
                                    variant="contained"
                                    required
                                    fullWidth
                                    size="small"
                                    style={{
                                        mt:3,
                                        mb:2,
                                        width:300,
                                        marginTop:2,
                                        marginBottom:10,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography variant='body2' color="primary.contrastText">
                                        Home (뒤로가기)</Typography>
                                </Button><br/>


                            </Box>


                        </div>
                    </div>
                </div>
            </Mobile>

        </>
    )
}